export default __webpack_public_path__ + "static/media/tete66.858838ad.png";